export default {
  Usuario: null,
  Login: null,
  EsLogged: false,
};
